var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeHumanIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.48805 0C3.80688 0 2.43913 1.36774 2.43913 3.04892C2.43913 4.73009 3.80688 6.09783 5.48805 6.09783C7.16922 6.09783 8.53697 4.73009 8.53697 3.04892C8.53697 1.36774 7.16922 0 5.48805 0ZM5.48805 4.87827C4.47947 4.87827 3.6587 4.0575 3.6587 3.04892C3.6587 2.04034 4.47947 1.21957 5.48805 1.21957C6.49663 1.21957 7.3174 2.04034 7.3174 3.04892C7.3174 4.0575 6.49663 4.87827 5.48805 4.87827ZM10.9761 11.5859V10.9761C10.9761 8.62295 9.06077 6.70762 6.70762 6.70762H4.26848C1.91472 6.70762 0 8.62295 0 10.9761V11.5859H1.21957V10.9761C1.21957 9.29493 2.58731 7.92719 4.26848 7.92719H6.70762C8.38879 7.92719 9.75654 9.29493 9.75654 10.9761V11.5859H10.9761Z",
    fill: "#FCB248"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeHumanIcon);
export default __webpack_public_path__ + "static/media/OrangeHumanIcon.2541efba46320a912c5a9a8bd9b3c36e.svg";
export { ForwardRef as ReactComponent };